import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { useSelect } from './SelectContext.js';
import { CategoryWrapper, Category } from './styles.js';

function DesktopCategory(_a) {
    var { children, label } = _a, props = __rest(_a, ["children", "label"]);
    const [{ filteredOptions, previousSelectedOptions, isSearched }] = useSelect();
    const filteredOptionsFromThisCategory = filteredOptions.filter((option) => option.category === label && !(previousSelectedOptions === null || previousSelectedOptions === void 0 ? void 0 : previousSelectedOptions.includes(option)));
    if (isSearched && !filteredOptionsFromThisCategory.length) {
        return null;
    }
    return (React.createElement(CategoryWrapper, Object.assign({}, props),
        React.createElement(Category, null, label),
        React.createElement("ul", { "aria-label": label }, children)));
}
function MobileCategory(_a) {
    var { children, label } = _a, props = __rest(_a, ["children", "label"]);
    return (React.createElement("optgroup", Object.assign({}, props, { label: label }), children));
}
function SelectCategory(props) {
    const [{ isMobile }] = useSelect();
    return isMobile ? (React.createElement(MobileCategory, Object.assign({}, props))) : (React.createElement(DesktopCategory, Object.assign({}, props)));
}

export { SelectCategory };
